import cc from "classcat";
import { memo } from "react";

import styles from "./RowDragIndicator.module.scss";

/**
 * Drag affordance rendered to the left of a customization row. The parent row
 * is responsible for `position: relative` and for revealing this on hover by
 * setting `--row-drag-indicator-opacity` / `--row-drag-indicator-events`.
 */
const RowDragIndicator = () => (
  <div className={styles["drag-indicator"]}>
    <div className={styles["drag-indicator-spacing"]}>
      <span
        className={cc([styles["drag-indicator-icon"], "narmi-icon-menu"])}
      />
    </div>
  </div>
);

export default memo(RowDragIndicator);
